import { render, staticRenderFns } from "./ActivateUserRecruiter.vue?vue&type=template&id=0d871d2c&scoped=true&"
import script from "./ActivateUserRecruiter.vue?vue&type=script&lang=js&"
export * from "./ActivateUserRecruiter.vue?vue&type=script&lang=js&"
import style0 from "./ActivateUserRecruiter.vue?vue&type=style&index=0&id=0d871d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d871d2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
